/******************************************************************************
 Taxonomy Lister Ajax
 ******************************************************************************/
;(function( $ ) {
	'use strict';

	$( document ).ready( function() {
		$( document ).on( 'click', '.widget .paging-nav', function( i ) {
			var $button = $( this ),
				$data   = $button.parents( '.widget' ).find( '.ajax_data' ),
				$target = $button.parents( '.widget' ).hasClass( 'ajax-target' ) ?
						  $button.parents( '.widget' ) : $button.parents( '.widget' ).find( '.ajax-target' ).last(),
				shown   = $( '#icit-shown-posts' ).data( 'shown-posts' ),
				query   = $data.data( 'query' ),
				nonce   = $data.data( 'nonce' ),
				start   = $data.data( 'start' ),
				end     = $data.data( 'end' ),
				layout  = $data.data( 'layout' ),
				site    = $data.data( 'site' ),
				url     = $data.data( 'url' ),
				known   = $data.data( 'known' ),
				data    = {
					'_icit_ajax': 'What did you hope to find?',
					'action': 'next_page',
					'query': query,
					'nonce': nonce,
					'start': start,
					'end': end,
					'layout': layout,
					'site': site,
					'shown': shown,
					'known': known
				};

			if ( !$button.hasClass( 'disabled' ) ) {
				$button.addClass( 'disabled' );
				$.post( url, data, function( d, st, xhr ) {
					$button.removeClass( 'disabled' );
					if ( d !== null && typeof( d ) === 'object' && d.start !== undefined ) {
						$data.data( 'start', d.start );
						$data.data( 'end', d.end );
						if ( d.html ) {
							$target.append( d.html );
						}
						if ( d.found <= d.end ) {
							$button.remove();
						}
					}
				}, 'json' );
			}
		} );
	} );
}( jQuery ));
